if (!customElements.get('product-tile')) {
  customElements.define(
    'product-tile',
    class ProductTile extends HTMLElement {
      constructor() {
        super();

        this.toggleButton = this.querySelector('[data-toggle-swatches]');
        this.toggleHover = this.querySelector('.product-tile-swatches-container');

        this.initSwatchToggle();
        this.initSwatchClicks();
        this.setupCarousel();
      }

      initSwatchToggle() {
        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', this.toggleSwatches.bind(this));
        }

        if (this.toggleHover) {
          this.toggleHover.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'touch') {
              this.toggleSwatches(e);
            }
          });
          this.toggleHover.addEventListener('pointerleave', (e) => {
            if (e.pointerType !== 'touch') {
              this.toggleSwatches(e);
            }
          });
        }
      }

      initSwatchClicks() {
        const swatches = this.querySelectorAll('[data-product-url]');

        swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.handleSwatchClick.bind(this));
          swatch.style.cursor = 'pointer';
        });
      }

      async handleSwatchClick(event) {
        const swatch = event.currentTarget;
        const productUrl = swatch.dataset.productUrl;

        if (!productUrl) return;

        try {
          // Update active swatch styling
          this.updateActiveSwatchStyling(swatch);
          const disableCarousel = !this.querySelector('.mini-carousel');

          // Fetch the new product page using the tile template
          const response = await fetch(`${productUrl}?view=${disableCarousel ? 'tile-sans-carousel' : 'tile'}`);
          const html = await response.text();

          // Parse the response and extract the product tile content
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProductTile = doc.querySelector('[id^="ProductTile-"]');

          if (newProductTile) {
            // Update only the ProductTile content using HTMLUpdateUtility
            const currentProductTile = this.querySelector('[id^="ProductTile-"]');
            if (currentProductTile) {
              HTMLUpdateUtility.viewTransition(currentProductTile, newProductTile);
              this.setupCarousel();
            }
          }
        } catch (error) {
          console.error('Error updating product tile:', error);
        }
      }

      updateActiveSwatchStyling(activeSwatch) {
        // Remove active styling from all swatches
        const allSwatches = this.querySelectorAll('[data-product-url]');
        allSwatches.forEach((swatch) => {
          swatch.classList.remove('!border-black');
          swatch.setAttribute('aria-pressed', 'false');
        });

        // Add active styling to clicked swatch
        activeSwatch.classList.add('!border-black');
        activeSwatch.setAttribute('aria-pressed', 'true');
      }

      toggleSwatches(event) {
        const swatchesId = this.toggleButton.getAttribute('aria-controls');
        const swatchesContainer = this.querySelector(`#${swatchesId}`);

        if (swatchesContainer) {
          const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';

          // Toggle visibility
          if (!isExpanded || event.type === 'pointerenter') {
            swatchesContainer.setAttribute('aria-hidden', 'false');
            swatchesContainer.classList.remove('hidden');
            this.toggleButton.setAttribute('aria-expanded', 'true');
            this.toggleButton.classList.add('hidden');

            if (event.type == 'click') swatchesContainer.firstElementChild.focus();
          } else {
            swatchesContainer.setAttribute('aria-hidden', 'true');
            swatchesContainer.classList.add('hidden');
            this.toggleButton.setAttribute('aria-expanded', 'false');
            this.toggleButton.classList.remove('hidden');
          }
        }
      }

      setupCarousel() {
        const elem = this.querySelector('.mini-carousel');
        if (elem) {
          const _ = new Flickity(elem, {
            dragThreshold: 20,
            wrapAround: true,
            imagesLoaded: true,
            contain: true,
            watchCSS: true,
            prevNextButtons: false,
          });
        }
      }
    },
  );
}
